import React from 'react';

import { GroupConsumer } from '../../../contexts/GroupContext';
import CommonCardShell from '../../Layout/CommonCardShell/CommonCardShell';
import GroupHomeLink from '../Elements/GroupHomeLink/GroupHomeLink';
import RulesCard from '../RulesCard/RulesCard';

import './RulesPage.scss';

export default class RulesPage extends React.PureComponent {
    constructor(props) {
        super();
    }

    render() {
        return (
            <div className="component-Groups-RulesPage">
                <CommonCardShell>
                    <GroupConsumer>
                        {({ group, userRelation }) => (
                            <RulesCard
                                displayText={
                                    group && group.rules
                                        ? group.rules
                                        : 'No rules are enforced for this group.'
                                }
                            />
                        )}
                    </GroupConsumer>

                    <GroupHomeLink />
                </CommonCardShell>
            </div>
        );
    }
}
